/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import AuthLayout from "./common/layouts/Auth";
import ErrorLayout from "./common/layouts/Error";
import FullLayout from "./common/layouts/Full";
import HomeScreen from "./screens/Home/HomeScreen";
import Evaluation from "./screens/Evaluation/EvaluationScreen";
import EvaluationForm from "./screens/Evaluation/EvaluationFormScreen";
import EvaluationCreate from "./screens/Evaluation/EvaluationCreateScreen";
import EvaluationEdit from "./screens/Evaluation/EvaluationEditScreen";
import EvaluationView from "./screens/Evaluation/EvaluationViewScreen";
import EvaluationDownloadPDF from "./screens/Evaluation/EvaluationDownloadPDF";
import VendorRegis from "./screens/VendorRegis/VendorRegisScreen";
import VendorSelfAssessmentScreen from "./screens/VendorSelfAssessment/VendorSelfAssessmentScreen";
import EvaluationResult from "./screens/EvaluationPtt/EvaluationResultScreen";
import EvaluationSiteByPtt from "./screens/EvaluationPtt/EvaluationSiteByPttScreen";
import EvaluationSelfByPtt from "./screens/EvaluationPtt/EvaluationSelfByPttScreen";
import RequestVendorCreate from "./screens/RequestVendor/RequestVendorCreateScreen";
import SiteVisitAssessmentScreen from "./screens/SiteVisitAssessment/SiteVisitAssessmentScreen";
export default [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/home" />,
  },
  {
    path: "/auth",
    component: AuthLayout,
    routes: [
      {
        path: "/auth/landing",
        exact: true,
        component: lazy(() => import("./screens/landing/landingScreen")),
      },
      {
        component: () => <Redirect to="/errors/404" />,
      },
    ],
  },
  {
    path: "/errors",
    component: ErrorLayout,
    routes: [
      {
        path: "/errors/401",
        exact: true,
        component: lazy(() => import("./screens/Error/Error401Screen")),
      },
      {
        path: "/errors/404",
        exact: true,
        component: lazy(() => import("./screens/Error/Error404Screen")),
      },
      {
        path: "/errors/500",
        exact: true,
        component: lazy(() => import("./screens/Error/Error500Screen")),
      },
      {
        component: () => <Redirect to="/errors/404" />,
      },
    ],
  },
  {
    route: "*",
    component: FullLayout,
    routes: [
      {
        path: "/home",
        exact: true,
        component: HomeScreen,
      },
      {
        path: "/Evaluation",
        exact: true,
        component: Evaluation,
      },
      {
        path: "/EvaluationGeneral/:menuParameter",
        exact: true,
        component: Evaluation,
      },
      {
        path: "/Evaluation/Create",
        exact: true,
        component: EvaluationCreate,
      },
      {
        path: "/Evaluation/Edit/:id",
        exact: true,
        component: EvaluationEdit,
      },
      {
        path: "/Evaluation/View/:id",
        exact: true,
        component: EvaluationView,
      },
      {
        path: "/Evaluation/Create/:id",
        exact: true,
        component: EvaluationCreate,
      },
      {
        path: "/Evaluation/Create1",
        exact: true,
        component: EvaluationForm,
      },{
        path: "/Evaluation/DownloadPDF/:id",
        exact: true,
        component: EvaluationDownloadPDF,
      },
      {
        path: "/VendorRegis/:menuParameter?",
        exact: true,
        component: VendorRegis,
      },
      {
        path: "/VendorSelfAssessment",
        exact: true,
        component: VendorSelfAssessmentScreen,
      },
      {
        path: "/EvaluationResult/:menuParameter",
        exact: true,
        component: EvaluationResult,
      },
      {
        path: "/EvaluationSiteByPtt/:menuParameter",
        exact: true,
        component: EvaluationSiteByPtt,
      },
      {
        path: "/EvaluationSelfByPtt/:menuParameter",
        exact: true,
        component: EvaluationSelfByPtt,
      },
      {
        path: "/RequestVendor/Create",
        exact: true,
        component: RequestVendorCreate,
      },
      {
        path: "/RequestVendor/Create/:id",
        exact: true,
        component: RequestVendorCreate,
      },
      {
        path: "/SiteVisitAssessment",
        exact: true,
        component: SiteVisitAssessmentScreen,
      },
      {
        component: () => <Redirect to="/errors/404" />,
      },
    ],
  },
];
